import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import { PipelineStage } from '../Stage';
import AverageStage from '../stages/preprocess/AverageStage';
import ProjectStage, { ProjectParams } from '../stages/transformations/ProjectStage';

export interface ProjectionParams extends BlockParameters, ProjectParams {}

@AddMetadata({ type: BlockKeys.Projection, name: 'Projections', description: 'Project the vectorial result to a suggested direction' })
class ProjectionBlock extends PipelineBlock<ProjectionParams> {
    constructor(params: ProjectionParams, id?: string) {
        super(params, id);
    }

    protected override defineStages(): PipelineStage<any>[] {
        return [new AverageStage(), new ProjectStage(this.getParams())];
    }
}

export default ProjectionBlock;
